<template>
  <Container type="card-full" v-loading="loading">
    <div>
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">采购人</div>
              <div class="view-value">{{ demandrecModel.comfullname }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">需求名称</div>
              <div class="view-value" style="width: 450px">{{ demandrecModel.demandname }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">需求编号</div>
              <div class="view-value">{{ demandrecModel.demandcode }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">采购类别</div>
              <div class="view-value">{{ demandrecModel.demandtypename  }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">预算金额</div>
              <div class="view-value" style="width: 450px">
                <span v-if="demandrecModel.demandbudgetamt"> ￥{{ demandrecModel.demandbudgetamt | qfwVal }}元 （ <amount :money="String(demandrecModel.demandbudgetamt)" />） </span>
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">创建人</div>
              <div class="view-value">{{ demandrecModel.demandcreateusername }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">创建日期</div>
              <div class="view-value">{{ formatTime(demandrecModel.demandcreatetime) }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">状态</div>
              <div class="view-value">{{ demandrecModel.statusDesc }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">需求描述</div>
              <div class="view-value" style="width: 550px">{{ demandrecModel.demanddescribe }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">需求文件</div>
              <div class="view-value">
                <div v-if="appendList.length" class="filelist" style="width: 100%;">
                  <div v-for="(item, index) in appendList" :key="index" class="fileitem" style="padding-left:0">
                    <div class="linkstyle" @click="downFile(item.appendurl, item.appendid)">
                      <a :src="uploadAddr + item.appendurl">{{ item.appendfilename | toolongOmitted }}</a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">下达人</div>
              <div class="view-value">{{ demandrecModel.demandsubmitusername }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">下达日期</div>
              <div class="view-value">{{ demandrecModel.demandsubmittime ? formatTime(demandrecModel.demandsubmittime) : '' }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">修改人</div>
              <div class="view-value">{{ demandrecModel.demandmodifyusername }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">修改日期</div>
              <div class="view-value">{{ demandrecModel.demandmodifytime? formatTime(demandrecModel.demandmodifytime) : '' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import request from '@/utils/request'
import utils from '../../assets/js/utils'
import common from '@/mixin/common'
import amount from '../common/amount'
import dayjs from 'dayjs'

// const SUCCESS = 1
export default {
  name: 'projectView',
  mixins: [common],
  components: { amount },
  data() {
    return {
      demandrecModel: {},
      loading: false,
      appendList: [],
      statusDesc: [
        { label: '起草中', value: '0' },
        { label: '已下达', value: '1' },
        { label: '已完成', value: '2' },
        { label: '已终止', value: '3' },
      ],
    }
  },

  deactivated() {
    this.$destroy()
  },
  mounted() {},
  filters: {
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value)
      } else {
        return value
      }
    },
  },
  async activated() {
    await this.getDetailById()
  },
  methods: {
    async getDetailById() {
      this.loading = true
      const damid = this.$store.state.app.damid 
      let { list = [], appendList = [] } = await request({
        url: '/xtgl/demandrec/getDetailById',
        method: 'get',
        params: { demandid: this.$route.query.id || damid },
      })
      this.demandrecModel = list[0]
      this.demandrecModel.statusDesc = this.statusDesc.find((s) => +s.value == +this.demandrecModel.demandstatus)?.label
      this.appendList = appendList
      this.loading = false
    },
    formatTime(value) {
      return dayjs(value).format('YYYY-MM-DD')
    },
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/table.scss';
@import '../../styles/filelist';
.linkstyle {
  color: #409EFF;
  display: block;
  cursor: pointer;
}
.view-content {
  width: 611px;
  color: #999999;

  span {
    color: #999999 !important;
  }
}
</style>
